/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type App_AddCurrency_QueryVariables = {
    serviceID: string;
};
export type App_AddCurrency_QueryResponse = {
    readonly service: {
        readonly " $fragmentRefs": FragmentRefs<"AddCurrency_service">;
    } | null;
};
export type App_AddCurrency_Query = {
    readonly response: App_AddCurrency_QueryResponse;
    readonly variables: App_AddCurrency_QueryVariables;
};



/*
query App_AddCurrency_Query(
  $serviceID: ID!
) {
  service: node(id: $serviceID) {
    __typename
    ... on Service {
      ...AddCurrency_service
    }
    id
  }
}

fragment AddCurrency_service on Service {
  id
  supportedCurrencies
  supportableCurrencies
  charges {
    edges {
      node {
        id
        name
        chargeIdentifier
        chargeType
        prices {
          amount
          currency
          id
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "serviceID"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "serviceID"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "App_AddCurrency_Query",
    "selections": [
      {
        "alias": "service",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AddCurrency_service"
              }
            ],
            "type": "Service",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "App_AddCurrency_Query",
    "selections": [
      {
        "alias": "service",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "supportedCurrencies",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "supportableCurrencies",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ChargeConnection",
                "kind": "LinkedField",
                "name": "charges",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ChargeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Charge",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "chargeIdentifier",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "chargeType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Price",
                            "kind": "LinkedField",
                            "name": "prices",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "amount",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "currency",
                                "storageKey": null
                              },
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Service",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "502028b1a1d15cd1a4699ce9749809b5",
    "id": null,
    "metadata": {},
    "name": "App_AddCurrency_Query",
    "operationKind": "query",
    "text": "query App_AddCurrency_Query(\n  $serviceID: ID!\n) {\n  service: node(id: $serviceID) {\n    __typename\n    ... on Service {\n      ...AddCurrency_service\n    }\n    id\n  }\n}\n\nfragment AddCurrency_service on Service {\n  id\n  supportedCurrencies\n  supportableCurrencies\n  charges {\n    edges {\n      node {\n        id\n        name\n        chargeIdentifier\n        chargeType\n        prices {\n          amount\n          currency\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'd33dee3b2ab97a1a920a15e123c43bed';
export default node;
